import React, { Component } from "react";
import { Grid, Button, Menu, MenuItem, Avatar } from "@material-ui/core";
import AppIcon from "images/logo.png";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Header.css";
import User from "util/user/User";
import LatestNewsWrap from "modules/ml-all-news/latest-news/LatestNewsWrap";
import Player from "modules/ml-player/Player";
import { togglePV } from "../../redux/actions/UserActions";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { appConfig } from "App";
class Header extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleToggle = () => (event) => {
    const {
      user: { previewVisible },
      togglePV,
    } = this.props;
    togglePV(previewVisible);
  };

  isCurrentPathSearch = () => {
    if (
      this.props &&
      this.props.location &&
      (this.props.location.pathname === "/search/albums" ||
        this.props.location.pathname === "/search/tracks" ||
        this.props.location.pathname === "/search" ||
        this.props.location.pathname === "/mladmin/trackranking" ||
        this.props.location.pathname === "/mladmin/albumranking")
    ) {
      return true;
    } else {
      return false;
    }
  };

  orgImage = () => {
    return this.props.user.credentials.orgs.find((v) => {
      return v.id === this.props.user.credentials.orgID;
    })?.orgImageUrl;
  };

  handleOrgMenuClick = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  };

  render() {
    const {
      classes,
      data: { selectedItem },
      trackTagCloud: { open: trackTagOpen },
      albumTagCloud: { open: albumTagOpen },
      user: { email, authenticated, previewVisible , credentials: { orgs, orgID },},
      location: { search , pathname},
    } = this.props;

    const {
      player: { playObject },
    } = this.props;

    const {anchorEl} = this.state;
    const { role } = orgID ? orgs.find((v) => v.id === orgID) : {};

    return (
      <Translation>
        {(t, { i18n }) => (
          <Grid container>
            <Grid item lg={7} md={7} xs={7} className={classes.mainwrap}>
            <div style={{display:"flex"}}>
            <div className={clsx(classes.playerHeader, "HeaderMainWrap")}>
              <div className={classes.headerLogoContainer}>
                <img
                  role="presentation"
                  src={AppIcon}
                  alt={t("header.SoundmouseLogo")}
                  className={classes.imglogo}
                />
              </div>
              <h1 className={classes.headingTxt}>{t("header.MusicManager")}</h1>

              
                {playObject && <Player />}
              </div>
              {selectedItem && selectedItem.id && (
                <>
                  {/* <div className={classes.trackName}>
                    {t("header.NowPlaying")}:
                    {selectedItem.title ? selectedItem.title : t("header.NA")}/
                    {selectedItem.artist ? selectedItem.artist : t("header.NA")}
                  </div> */}
                  {/* <AudioPlayer
                    className={classes.player}
                    src={selectedItem.preview_url}
                    onPlay={(e) => console.log("onPlay")}
                  /> */}
                </>
              )}
             </div>
            </Grid>
            <Grid item lg={5} md={5} xs={5} className={classes.mainwrap}>
              <div id="header-items" className={classes.headerObjects}>
                <div id="header-orgs" className={clsx(classes.orgLogo, "OrgLogoHeader")}>
                  <Button id="org-navi" className={classes.orgButton} aria-controls="org-menu" aria-haspopup="true" onClick={this.handleOrgMenuClick}>
                    <div className={classes.orgFlexed}>
                      <img
                        src={this.orgImage()}
                        role="presentation"
                        alt="Org Logo"
                        key="user-org"
                        class="OrgLogoInside"
                      /><ExpandMoreIcon />
                      {/* <span key="user-role" className={classes.orgName}>{role}</span> */}
                    </div>
                  </Button>
                  <Menu
                    id="org-menu"
                    key="org-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    className={classes.dropOrgMenu}
                    open={Boolean(anchorEl)}
                    onClose={()=>this.setState({ anchorEl: null })}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                  >
                    {/* <MenuItem onClick={()=>this.setState({ anchorEl: null })}> </MenuItem> */}
                    {orgs.map((v) => (
                            <MenuItem
                            id={`org-navi-item-` + v.id}
                              key={v.id}
                              value={v.id}
                              disabled={orgID == v.id ? true : false}
                              className={
                                clsx(
                                classes.orgList,
                                orgID == v.id
                                  ? classes.selected
                                  : classes.notSelected
                             ) }
                              onClick={()=>this.setState({ anchorEl: null })}
                            >
                              <a
                               className={classes.orgFlexed}
                                href={
                                  "https://" +
                                  v.id +
                                  "." +
                                  appConfig.MB_DOMAIN +
                                  "/tourl?url=&origin=" +
                                  orgID +
                                  "." +
                                  appConfig.MB_DOMAIN +
                                  "&org=" +
                                  encodeURIComponent(btoa(v.id)) +
                                  "&user=" +
                                  encodeURIComponent(btoa(email))
                                }
                              >
                                <Avatar
                                  alt={v.name}
                                  className={classes.userWorkspaceImage}
                                  variant="square"
                                  src={v.orgImageUrl}
                                >
                                  {v.name}
                                </Avatar>
                               <div>{v.name}
                                <span key="user-role" className={classes.orgName}>{v.role}</span>
                                </div> 
                              </a>
                            </MenuItem>
                        ))}
                  </Menu>
                </div>
                {authenticated ? <LatestNewsWrap /> : <></>}
                {authenticated ? <User /> : <></>}
                {(search && search.includes("?uploadTracks") || pathname && pathname.includes("/downloader/"))
                  ? null
                  : this.isCurrentPathSearch() &&
                  !trackTagOpen &&
                  !albumTagOpen && (
                    <Button
                      className={classes.headerExpandableButton}
                      aria-label="Right Expandable Button"
                      onClick={this.handleToggle()}
                    >
                      {previewVisible ? <FaAngleRight /> : <FaAngleLeft />}
                    </Button>
                  )}
                {(search && search.includes("?uploadTracks") || pathname && pathname.includes("/downloader/"))
                  ? null
                  : !this.isCurrentPathSearch() && (
                    <Button
                      className={classes.headerExpandableButton}
                      aria-label="Right Expandable Button"
                      onClick={this.handleToggle()}
                    >
                      {previewVisible ? <FaAngleRight /> : <FaAngleLeft />}
                    </Button>
                  )}
              </div>
            </Grid>
          </Grid>
        )}
      </Translation>
    );
  }
}

Header.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  player: state.player,
  trackTagCloud: state.mltracklibrary.tagCloud,
  albumTagCloud: state.mlalbum.tagCloud,
});

export default connect(mapStateToProps, { togglePV })(
  withStyles(styles)(withRouter(Header))
);
